import * as _ from 'lodash';
import { Router } from '@angular/router';
import { FETCH_COUPONS_REQUESTED } from './../list/list.actions';
import { DELETE_COUPON_REQUESTED, GET_COUPON_REQUESTED, GET_COUPON_SUCCEEDED, EDIT_COUPON_REQUESTED } from './edit.actions';
import { takeEvery, put } from 'redux-saga/effects';
import { API_CALL_ERROR } from './../../../store/action';
import { ApiService } from './../../../api/api.service';
import { AppInjector } from './../../../app-injector';
import {CARTRULE_COMP} from "../../cartrule/cartrule.action";
import {GET_CARTRULE_REQUESTED} from "../../cartrule/edit/edit.actions";
import {UtilityService} from "../../../common/services/utility/utility.service";
import Redirect from "../../../models/Redirect";

function* editCoupon(action) {
  const api = AppInjector.get(ApiService);
  const router = AppInjector.get(Router);
  try {
    let result = yield api.coupon.update(action.data).toPromise();
    AppInjector.get(UtilityService).redirectAndReset('coupon');
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchEditCouponRequest() {
  yield takeEvery(EDIT_COUPON_REQUESTED, editCoupon);
}

function* getCoupon(action) {
  const api = AppInjector.get(ApiService);
  try {
    let result = yield api.coupon.getItemById(action.data).toPromise();
    yield put({ type: GET_COUPON_SUCCEEDED, data: result });
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchGetCouponRequest() {
  yield takeEvery(GET_COUPON_REQUESTED, getCoupon);
}

function* deleteCoupon(action) {
  const api = AppInjector.get(ApiService);
  try {
    let result = yield api.coupon.delete(action.data).toPromise();
    if (!_.isUndefined(action.com)) {
      if (action.com === CARTRULE_COMP) {
        yield put({ type: GET_CARTRULE_REQUESTED, data: action.cartruleId });
      } else {
        yield put({ type: FETCH_COUPONS_REQUESTED });
      }
    } else {
      yield put({ type: FETCH_COUPONS_REQUESTED });
    }
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchDeleteCouponRequest() {
  yield takeEvery(DELETE_COUPON_REQUESTED, deleteCoupon);
}

export default [watchEditCouponRequest, watchGetCouponRequest, watchDeleteCouponRequest];
